import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { FinalTaxesAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesAsset';

export class FinalTaxesOtherInvestmentAsset extends FinalTaxesAsset {
  accountName?: string;
  marketValue?: number;
  purchasePrice?: number;
  rollOver?: boolean;

  constructor(model: Partial<FinalTaxesOtherInvestmentAsset> = {}) {
    super(model);

    this.accountName = model.accountName ?? '';
    this.marketValue = model.marketValue ?? 0;
    this.purchasePrice = model.purchasePrice ?? 0;
    this.rollOver = model.rollOver ?? false;
  }

  getModelName(): ModelType {
    return ModelType.FINAL_TAXES_OTHER_INVESTMENT_ASSET;
  }
}
